import { createReducer } from '_/utils/redux'
import { GET_AREA_OF_ACTIVITY_LIST, GET_AREA_OF_ACTIVITY_META } from './actions'

const { List, Record } = require('immutable')

const INITIAL_STATE = new Record({
  areasOfActivityList: List(),
  areaOfActivityMeta: {},
})()

export default createReducer(INITIAL_STATE, {
  [GET_AREA_OF_ACTIVITY_LIST.FULFILLED]: (state, { payload }) => {
    return state.set('areasOfActivityList', payload.results)
  },
  [GET_AREA_OF_ACTIVITY_META.FULFILLED]: (state, { payload }) => {
    return state.set('areaOfActivityMeta', payload)
  },
})
